import Vue from "vue";
import i18n from "../../i18n";
import store from "@/store/store";

const state = {
  payment_id: null,
  email: null,
  license_plate: null
};

const actions = {
  startPayment(context, payload) {
    let url = null;
    context.commit("email", payload.body.customer.email);
    let license_plate = payload.body.customer.license_plate;
    if (license_plate) {
      license_plate = license_plate.toUpperCase();
    }
    context.commit("license_plate", license_plate);
    if (payload.authenticated) {
      url = "/api/webshop-payment/v1";
      payload.body.payment_provider_redirect_url =
        window.location.origin + "/webshopredirect";
    } else {
      url = "/api/non-portal/webshop-payment/v1";
      payload.body.payment_provider_redirect_url =
        window.location.origin + "/webshop-portal/webshopredirect";
    }

    Vue.prototype.$http
      .post(url, payload.body)
      .then(response => {
        context.commit("payment_id", response.data.payment_id);
        window.location.href = response.data.mollie_url;
      })
      .catch(error => {
        payload.modal.busy = false;
        if (
          error.response.status === 400 &&
          error.response.data.error != null
        ) {
          store.commit("viewstate/notify", {
            text: i18n.t("error." + error.response.data.error),
            color: "error"
          });
        } else {
          store.commit("viewstate/notify", {
            text: i18n.t("error.something_went_wrong"),
            color: "error"
          });
        }
      });
  },

  getPaymentResult(context) {
    return Vue.prototype.$http.get(
      "api/webshop-payment/v1/status/" + context.state.payment_id
    );
  },

  getPaymentById(context, payload) {
    return Vue.prototype.$http.get("api/webshop-payment/v1/" + payload);
  },

  getPayments(context, payload) {
    return Vue.prototype.$http.get("api/webshop-payment/v1/" + payload);
  },

  getProduct(context, payload) {
    return Vue.prototype.$http.get("api/webshop/products/v1/" + payload);
  },

  getWebshopPaymentUnauthenticated(context) {
    return Vue.prototype.$http.get(
      "api/non-portal/webshop-payment/v1/status/" + context.state.payment_id
    );
  },

  validateLicensePlate(context, payload) {
    return Vue.prototype.$http.post(
      "/api/non-portal/webshop-payment/v1/validate-license-plate",
      payload
    );
  }
};

const mutations = {
  payment_id(state, payload) {
    state.payment_id = payload;
  },
  email(state, payload) {
    state.email = payload;
  },
  license_plate(state, payload) {
    state.license_plate = payload;
  }
};

export const webshop = {
  namespaced: true,
  state,
  actions,
  mutations
};
